// Mock data for BTSSOFT XAI website

export const heroData = {
  title: "XAI - Ximple Accounting System",
  subtitle: "Sistem ERP & Akuntansi Terintegrasi untuk UMKM Indonesia",
  description: "Kelola bisnis Anda dari transaksi harian hingga laporan keuangan lengkap dengan integrasi WhatsApp, Web, API, Apps, dan Dashboard yang powerful.",
  primaryCta: "Hubungi untuk Konsultasi",
  secondaryCta: "Lihat Demo",
  logoUrl: "https://customer-assets.emergentagent.com/job_139a1b8f-e7a3-436b-b3e2-334218a84ff2/artifacts/ujujlmbw_Logo%20BTSSOFT%20Realistic%202025.09.png",
  dashboardUrl: "https://customer-assets.emergentagent.com/job_139a1b8f-e7a3-436b-b3e2-334218a84ff2/artifacts/yy4r3t1a_dashboard%20xai%202.JPG",
  dashboardUrl2: "https://customer-assets.emergentagent.com/job_ximple-showcase/artifacts/juxvm5su_gambar%20xasys%20dalam%20imac.png"
};

export const integrationFeatures = [
  {
    id: 1,
    title: "WhatsApp Integration", 
    description: "Terima notifikasi transaksi dan laporan langsung via WhatsApp. Kelola bisnis dari mana saja dengan mudah.",
    icon: "whatsapp",
    iconUrl: "https://customer-assets.emergentagent.com/job_ximple-showcase/artifacts/3l6epv0r_whatsapp-logo-icon-free-png.webp"
  },
  {
    id: 2,
    title: "Web Dashboard",
    description: "Dashboard web yang powerful untuk monitoring real-time, analisis mendalam, dan kontrol penuh atas bisnis Anda.",
    icon: "BarChart3"
  },
  {
    id: 3,
    title: "API Integration",
    description: "Koneksi seamless dengan sistem lain melalui REST API. Integrasikan dengan e-commerce, bank, dan platform lainnya.",
    icon: "n8n",
    iconUrl: "https://customer-assets.emergentagent.com/job_ximple-showcase/artifacts/o6t9u21k_n8nio.webp"
  },
  {
    id: 4,
    title: "Mobile Apps",
    description: "Aplikasi mobile untuk input transaksi, cek stok, dan monitoring bisnis kapan saja, di mana saja.",
    icon: "Smartphone"
  },
  {
    id: 5,
    title: "Advanced Dashboard",
    description: "Visualisasi data yang interaktif dengan chart, grafik, dan reports yang dapat dikustomisasi sesuai kebutuhan.",
    icon: "LineChart"
  },
  {
    id: 6,
    title: "Multi-Platform",
    description: "Akses dari Windows, Mac, Linux, iOS, dan Android. Satu sistem untuk semua kebutuhan bisnis Anda.",
    icon: "Grid3x3"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "Rp 299.000",
    period: "/bulan",
    description: "Perfect untuk UMKM yang baru memulai digitalisasi",
    features: [
      "1 User",
      "Basic Accounting",
      "WhatsApp Notifications",
      "Web Dashboard",
      "Email Support",
      "Data Storage 1GB"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "Rp 599.000", 
    period: "/bulan",
    description: "Ideal untuk bisnis yang berkembang dengan kebutuhan integrasi",
    features: [
      "5 Users",
      "Complete ERP Features",
      "All Integrations",
      "API Access",
      "Mobile Apps",
      "Priority Support",
      "Data Storage 10GB",
      "Custom Reports"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "Solusi lengkap untuk perusahaan besar dengan kebutuhan khusus",
    features: [
      "Unlimited Users",
      "Full Customization",
      "Dedicated Support",
      "On-Premise Option",
      "Advanced Analytics",
      "White Label",
      "Training & Consultation",
      "SLA Guarantee"
    ],
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Budi Santoso",
    company: "Toko Elektronik Jaya",
    content: "XAI mengubah cara kami mengelola bisnis. Dari pencatatan manual ke sistem terintegrasi, omzet naik 30% dalam 6 bulan!",
    rating: 5
  },
  {
    id: 2,
    name: "Sari Dewi",
    company: "Warung Makan Sederhana",
    content: "Integrasi WhatsApp sangat membantu. Saya bisa pantau penjualan harian dan stok dari rumah. Praktis sekali!",
    rating: 5
  },
  {
    id: 3,
    name: "Ahmad Rahman",
    company: "Konveksi Berkah",
    content: "API integration memungkinkan kami connect dengan marketplace. Orderan otomatis masuk ke sistem, efisiensi tinggi!",
    rating: 5
  }
];

export const companyInfo = {
  name: "BTSSOFT",
  description: "Software Developer specializing in ERP Software and Accounting Systems",
  email: "support@btssoft.com",
  phone: "+6281218691110",
  address: "Medan, Indonesia",
  social: {
    instagram: "https://instagram.com/btssoftmdn"
  }
};

export const demoFeatures = [
  {
    title: "Input Transaksi Harian",
    description: "Interface sederhana untuk mencatat penjualan, pembelian, dan kas masuk/keluar",
    image: "/api/placeholder/400/300"
  },
  {
    title: "Laporan Keuangan Otomatis", 
    description: "Generate Neraca, Laba Rugi, dan Cash Flow secara otomatis",
    image: "/api/placeholder/400/300"
  },
  {
    title: "Dashboard Real-time",
    description: "Monitor performa bisnis dengan grafik dan chart yang update real-time",
    image: "/api/placeholder/400/300"
  }
];